import React, { useState, useRef, useEffect, useLayoutEffect } from "react"
import { Main, WLoader } from "./styles"
import { useTransform } from "framer-motion"
import { EMPTY_STRING, KILL_ROUTE } from "./../constants"
import { useWatchVariations, mvSubscribe } from "./../context"
import { rafDelay } from "./../utils"
import Image from "components/media/ImageCLD"
import { useEnv } from "contexts/Env"
import { ToggleRoller } from "./../WatchRoller"

function ToggleButton({ children, ctx, index }) {
    const { toggle } = useWatchVariations(ctx)
    const rfmain = useRef(null)

    function onClick(e) {
        toggle.set(index)
    }

    function onToggle(v) {
        rfmain.current?.classList[v === index ? "remove" : "add"]("cfg-toggle-off")
    }

    useEffect(() => mvSubscribe("ToggleButton toggle", toggle, onToggle), [])

    return (
        <button ref={rfmain} aria-label="" onClick={onClick}>
            {children}
        </button>
    )
}

export function Toggle({ ctx, rctx }) {
    const { route, active, entry, wactive, wentry, toggle } = useWatchVariations(ctx)
    const rfmain = useRef(null)
    const env = useEnv()

    const entry_picture = {
        public_id: `catalogue/${env.catalogYear}/upright-c/${entry.get()}`,
        version: 1,
        width: 800,
        height: 1180,
        policy: "t_v7-main-configurator"
    }

    return (
        <Main ref={rfmain} aria-live='polite'>
            <ToggleButton ctx={ctx} index={0}>
                <Image sources={[entry_picture]} loading='eager' sizes='(min-width: 48rem) 33vw, 50vw' />
            </ToggleButton>
            <ToggleButton ctx={ctx} index={1}>
                <ToggleRoller ctx={ctx} rctx={rctx} />
            </ToggleButton>
        </Main>
    )
}
